import React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';
import { FiPlay, FiX, FiArrowDown } from 'react-icons/fi';
import ScrollAnimation from 'react-animate-on-scroll';
import Helmet from 'react-helmet';
import CTA from '../components/CTA';
import DefaultLayout from '../layouts';
import * as styles from './product-old.module.styl';
import Button from '../components/Button';
import Rotator from '../components/Rotator';

const defaultApps = [
  {
    slug: 'google-sheets',
    title: 'Google Sheets',
    images: {
      url_128x128:
        'https://zapier-images.imgix.net/storage/services/8913a06feb7556d01285c052e4ad59d0.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128',
    },
    hex_color: '00a256',
  },
  {
    slug: 'mailchimp',
    title: 'Mailchimp',
    images: {
      url_128x128:
        'https://zapier-images.imgix.net/storage/services/221770b81f376004aee4a712ef4353be.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128',
    },
    hex_color: 'FFE01B',
  },
  {
    slug: 'activecampaign',
    title: 'ActiveCampaign',
    images: {
      url_128x128:
        'https://zapier-images.imgix.net/storage/developer/d3f66e256c0d227d06b0686d724badad.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128',
    },
    hex_color: '3463a3',
  },
  {
    slug: 'trello',
    title: 'Trello',
    images: {
      url_128x128:
        'https://zapier-images.imgix.net/storage/services/da3ff465abd3a3e1b687c52ff803af74.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128',
    },
    hex_color: '0079bf',
  },
  {
    slug: 'slack',
    title: 'Slack',
    images: {
      url_128x128:
        'https://zapier-images.imgix.net/storage/services/6cf3f5a461feadfba7abc93c4c395b33_2.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128',
    },
    hex_color: '510f4d',
  },
  {
    slug: 'hubspot',
    title: 'HubSpot',
    images: {
      url_128x128:
        'https://zapier-images.imgix.net/storage/developer/cde9764aa8d19fdd6d591455dbe5a78d.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128',
    },
    hex_color: 'f7761f',
  },
  {
    slug: 'convertkit',
    title: 'ConvertKit',
    images: {
      url_128x128:
        'https://zapier-images.imgix.net/storage/services/a1a7697d691ddd7434a69e16e672b495.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128',
    },
    hex_color: 'FF4C66',
  },
  {
    slug: 'mailerlite',
    title: 'MailerLite',
    images: {
      url_128x128:
        'https://zapier-images.imgix.net/storage/developer/adad4caf0ceedcdec2102234789a44f9.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128',
    },
    hex_color: '00A154',
  },
  {
    slug: 'aweber',
    title: 'AWeber',
    images: {
      url_128x128:
        'https://zapier-images.imgix.net/storage/services/f587519f1f449abb2d3d0e7942e486b5.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128',
    },
    hex_color: '1073bd',
  },
  {
    slug: 'campaign-monitor',
    title: 'Campaign Monitor',
    images: {
      url_128x128:
        'https://zapier-images.imgix.net/storage/developer/2808fc5749049848d5980cfec02066a2.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128',
    },
    hex_color: '72d0eb',
  },
  {
    slug: 'mailshake',
    title: 'Mailshake',
    images: {
      url_128x128:
        'https://zapier-images.imgix.net/storage/developer/149cdd20ff05db1b13c6686bc4e2f073.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128',
    },
    hex_color: '005AAC',
  },
  {
    slug: 'google-drive',
    title: 'Google Drive',
    images: {
      url_128x128:
        'https://zapier-images.imgix.net/storage/services/bb735e567f1a1e9e3b8b7241497c2d43.png?auto=format%2Ccompress&fit=crop&h=128&ixlib=python-3.0.0&q=50&w=128',
    },
    hex_color: 'f4b400',
  },
];

const jpeg_1800 = `https://img.paperform.co/fetch/f_jpg,w_1800/https://paperform.co`;

function Tab(props) {
  return (
    <div className={classnames(styles.tab, props.className)}>
      {props.children}
    </div>
  );
}

function PaymentsTab() {
  return (
    <Tab className={styles.paymentTab}>
      <img
        alt=""
        src="/images/logos--vertical.png"
        className={classnames(styles.logo)}
      />
    </Tab>
  );
}

// const SubscriptionsTab = props => (
//   <Tab>
//     <img alt=""
//       src={'/images/subscriptions.png'}
//       className={classnames(styles.logo)}
//     />
//   </Tab>
// )

function ProductsTab() {
  return (
    <Tab>
      <img alt="" className="lozad auto" data-src="/images/products.png" />
    </Tab>
  );
}

function DonationsTab() {
  return (
    <Tab className={styles.donations}>
      <div className={styles.fakeLabel}>How much would you like to give?</div>
      <div className={styles.fakeInput} />
    </Tab>
  );
}

export function WhatIsPaperformSection() {
  return (
    <div className={styles.whatIsPaperform}>
      <div className={styles.whatIsPaperformBanner} />
      <h1>
        Paperform is a web platform that enables <i>anyone</i> to create
        beautiful online forms, payment or product pages, quickly and
        intuitively, without any technical knowledge.
      </h1>
    </div>
  );
}

export function QuestionTypesSection() {
  return (
    <div className={styles.questionTypes}>
      <div className={styles.questionTypesBanner} />
      <div className={styles.questionTypesInner}>
        <h2>Oh, we've got a question type for that!</h2>
        <p>Over 22 unique question types, and counting.</p>
        <div
          data-paperform-id="jiwidssx"
          data-direct={1}
          style={{
            zIndex: 1,
            position: 'relative',
            marginBottom: -180,
            marginTop: '2rem',
            minHeight: 345,
          }}
        />
      </div>
    </div>
  );
}

export function LandingFormsSection({
  title = "More than a form, more than landing page, it's a landing form.",
  description = ` Not just questions and answers, you can insert pictures, videos and styled text anywhere on the page. Every form has its own URL, so you can share the form with or without your own website.`,
}) {
  return (
    <div className={styles.landingForm}>
      <div className={styles.landingFormBanner} />
      <div className={styles.landingFormInner}>
        <div className={styles.landingFormImg2}>
          <img
            alt=""
            src="/images/course-feedback.paperform-Apple iPhone 7 Plus Rose Gold [shadow].png"
          />
        </div>
        <div className={styles.landingFormContent}>
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
        <div className={styles.landingFormImg1}>
          <img
            alt=""
            src="/images/mmgj6prk.paperform-Apple-Macbook-Space-Grey-[shadow].png"
          />
        </div>
      </div>
    </div>
  );
}

export function PaymentsSection({
  title = 'Money Please.',
  description = 'Paperform takes all the pain out of taking payments with Stripe, Paypal Business, Braintree and Square.',
}) {
  return (
    <Rotator
      wrapperClassName={styles.payments}
      colorize={false}
      reverse={false}
      interval={3}
      header={
        <span>
          <h2>{title}</h2>
          <p
            style={{
              maxWidth: '30rem',
              margin: '0 auto',
              marginBottom: '2rem',
            }}
          >
            {description}
          </p>
        </span>
      }
      borderless
      options={[
        {
          label: 'Payments',
          content: () => <PaymentsTab />,
        },
        {
          label: 'Products',
          content: () => <ProductsTab />,
        },
        {
          label: 'Subscriptions',
          content: '/images/subscriptions.png',
        },
        /* {
                  label:`Quotes`,
                  content:() => <QuotesTab />
                }, */
        {
          label: 'Donations',
          content: () => <DonationsTab />,
        },
      ]}
    />
  );
}

export function BookingsSection() {
  return (
    <div className={styles.bookings}>
      <div>
        <h2>Take bookings, along with everything else.</h2>
        <p>
          With <Link to="/scheduling-software/">Bookings for Paperform</Link>{' '}
          you can schedule appointments seamlessly with the rest of your form.
        </p>
      </div>

      <div>
        <img
          alt=""
          className="lozad auto"
          data-src="/images/undraw_schedule_pnbk.svg"
        />
        <p className={styles.bookingsDesc}>
          Connect your own Google Calendar to sync availability and
          automatically create Calendar events on submission.
        </p>
      </div>
    </div>
  );
}

export function LogicSection() {
  return (
    <div className={styles.logic}>
      <div>
        <h2>Smart forms for smart people.</h2>
        <p>
          Only ask the relevant questions, and control your customer's
          experience depending on how they answer the form.
        </p>
      </div>
      <img alt="" className="lozad auto" data-src="/images/logic-setup.png" />
      <div>
        <p>
          Define your own <strong>logic rules</strong> to control when
          questions, pages, sections of content, and success pages should be
          displayed to your submitters, or even when custom emails should send.
        </p>
      </div>
    </div>
  );
}

export function ResultsSection({
  title = 'Embed, Share, Analyse',
  description = 'Seamlessly embedded forms on your website, or share directly with a custom URL. Analyse results on Paperform.',
  reverse,
}) {
  return (
    <Rotator
      wrapperClassName={styles.payments}
      colorize={false}
      reverse={reverse}
      interval={5}
      header={
        <span>
          <h2>{title}</h2>
          <p
            style={{
              maxWidth: '20rem',
              margin: '0 auto',
              marginBottom: '2rem',
            }}
          >
            {description}
          </p>
        </span>
      }
      options={[
        {
          label: 'Embed',
          content: `${jpeg_1800}/images/embed.png`,
          description: (
            <span className={styles.embedTooltip}>
              Embed on your website, anywhere you can drop a HTML snippet, or
              anywhere embed.ly is supported.
            </span>
          ),
        },
        {
          label: 'Share',
          content: `${jpeg_1800}/images/share.jpg`,
          description: (
            <span className={styles.embedTooltip}>
              Every form has it's own URL that you can share on Social or via
              Email.
            </span>
          ),
        },
        {
          label: 'Analyse',
          content: `${jpeg_1800}/images/analyse.png`,
          description: (
            <span className={styles.embedTooltip}>
              Export results to CSV or look at the built in report and analytics
              on Paperform
            </span>
          ),
        },
      ]}
    />
  );
}

export function AfterSubmissionSection({
  apps = defaultApps,
  hideIntegrations = false,
}) {
  return (
    <div className={styles.afterSubmission}>
      <h2 style={{ fontSize: '2rem' }}>
        Clicking <span className={styles.submit}>submit</span> is just the
        beginning
      </h2>
      <ScrollAnimation animateIn={styles.svgAnim} animateOnce>
        <FiArrowDown className={styles.step1} />
        <div className={styles.blockLeft}>
          <img
            alt=""
            src="/images/plane-green.svg"
            className={styles.hideSm}
            style={{ width: '7rem', margin: '2rem', marginTop: 0 }}
          />
          <img
            alt=""
            src="/images/plane-red.svg"
            className={styles.hideSm}
            style={{ width: '16rem', margin: '5rem', marginTop: 0 }}
          />
          <img
            alt=""
            src="/images/plane.svg"
            style={{ width: '12rem', margin: '3rem', marginTop: 0 }}
          />
          <p>
            Automatically receive a submission summary in your inbox, or send
            custom emails to yourself, the submitter or anyone else.
          </p>
        </div>
      </ScrollAnimation>
      <ScrollAnimation animateIn={styles.svgAnim} animateOnce>
        <FiArrowDown className={styles.step1} />
        <div className={styles.blockRight}>
          <img
            alt=""
            className="lozad auto"
            data-src="/images/turtle.jpg"
            style={{ width: '15rem' }}
          />
          <p>
            Show a success message that is tailored to the responses, or
            redirect the submitter to another page.
          </p>
        </div>
      </ScrollAnimation>

      {hideIntegrations ? null : (
        <ScrollAnimation animateIn={styles.svgAnim} animateOnce>
          <FiArrowDown className={styles.step1} />
          <div className={styles.integrationsBlock}>
            <h2>Integrate with your apps</h2>
            <p style={{ opacity: 0.6 }}>
              Use our Direct Integrations to connect your forms to lots of
              popular apps, or use Zapier, Make and webhooks to connect with
              over 1000 other apps. Want something custom?{' '}
              <Link to="/developer/api-v1-documentation/">
                Check out our API
              </Link>
              .
            </p>
            <div style={{ margin: '1rem auto' }}>
              <Button to="/integrations/">Go to Integrations</Button>
            </div>
            {apps.map((app) => (
              <Link
                to={`/integrations/${app.slug}/`}
                key={app.slug}
                className={styles.app}
                style={{
                  backgroundImage: `url(${app.images.url_128x128})`,
                }}
                alt={app.title}
              />
            ))}
          </div>
        </ScrollAnimation>
      )}
    </div>
  );
}

function CTASection() {
  return (
    <div className={styles.cta}>
      <h2>Try Paperform now.</h2>
      <CTA />
    </div>
  );
}

class Product extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleEsc);
    this.refs.video.playbackRate = 2;
    if (!window.Paperform) {
      const s = document.createElement('script');
      s.src = 'https://paperform.co/__embed.min.js';
      document.body.appendChild(s);
    }
  }

  handleEsc = (e) => {
    if (e.code === 'Escape') {
      this.setState({
        showingDemo: false,
      });
    }
  };

  showDemo() {
    this.setState({
      showingDemo: true,
    });
  }

  render() {
    return (
      <DefaultLayout location={this.props.location} invertNav>
        <Helmet titleTemplate={false}>
          <title>
            Easy, Beautiful, Yours — Online Form Builder And Form Creator |
            Paperform
          </title>
          <meta
            name="description"
            content="Paperform is an online tool that enables to easily create beautiful forms, payment or product pages that feel truly yours."
          />
          <meta
            property="og:title"
            content="Easy, Beautiful, Yours — Online Form Builder And Form Creator | Paperform"
          />
          <meta
            property="og:description"
            content="Paperform is an online tool that enables to easily create beautiful forms, payment or product pages that feel truly yours."
          />
        </Helmet>
        <div className={classnames(styles.flex, styles.hero)}>
          <div className={styles.heroText}>
            <h1>Create any form, for any need, fast.</h1>
            <Button pink raised solid href="/register">
              Start free trial
            </Button>
            <br />
          </div>
          <div className={styles.demo}>
            <video
              autoPlay={1}
              loop={1}
              muted={1}
              ref="video"
              poster="/images/cover.png"
              className={styles.video}
            >
              <source src="/videos/web.mp4" type="video/mp4" />
              <source src="/videos/web.webm" type="video/webm" />
            </video>
            <div className={styles.demoPlay} onClick={() => this.showDemo()}>
              <FiPlay />
            </div>
          </div>
        </div>
        <WhatIsPaperformSection />
        <QuestionTypesSection />
        <LandingFormsSection />
        <PaymentsSection />
        <BookingsSection />
        <LogicSection />
        <ResultsSection reverse />
        <AfterSubmissionSection />
        <CTASection />
        <div
          className={classnames(
            styles.demoPopup,
            this.state.showingDemo ? styles.demoPopupOpen : null,
          )}
        >
          <FiX onClick={() => this.setState({ showingDemo: false })} />
          {this.state.showingDemo ? (
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/pkZE0M-fr4o?rel=0&amp;showinfo=0&autoplay=1"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              title="Paperform Demo"
            />
          ) : null}
        </div>
      </DefaultLayout>
    );
  }
}

export default Product;
